import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './FireDamagePage.metadata.json5';
import LossPropertyIncidentDetail from './../LossPropertyIncidentDetails/LossPropertyIncidentDetails';

function FNOLFireDamagePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        }
    } = props;
    const { claimStatus } = state;
    const translator = useContext(TranslatorContext);

    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation
    } = useValidation('FNOLHOFireDamagePage');

    const initialiseVM = useCallback(() => {
        claimVM.lobs.homeowners.propertyFireDamage.value = !_.isEmpty(
            claimVM.lobs.homeowners.propertyFireDamage.value
        )
            ? claimVM.lobs.homeowners.propertyFireDamage.value
            : {
                isHomeHabitable: false,
                isHomeSecure: false,
                fireDeptResponded: false,
                emsreponded_EY: false,
                isAnyoneInjured: false,
                smokeDamageOnly: false                
            };
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.isHomeSecure'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.isHomeSecure', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.isHomeHabitable'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.isHomeHabitable', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.fireDeptResponded'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.fireDeptResponded', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.emsreponded_EY'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.emsreponded_EY', '');
        }        
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.isAnyoneInjured'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.isAnyoneInjured', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.smokeDamageOnly'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyFireDamage.smokeDamageOnly', '');
        }
        return claimVM;
    }, [claimVM]);

    const isClaimStatus = useCallback(() => {
        return ((_.get(claimVM.value, 'lossCause') === 'fire' && !_.isEmpty(claimStatus)));
    }, [claimStatus, claimVM]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
    }, [registerInitialComponentValidation, isClaimStatus]);

    useEffect(
        () => {
            const nextclaimVM = initialiseVM();
            updateWizardData(nextclaimVM);
        },
        // Call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const overrides = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        propertyID: {
            //model: claimVM.lobs.homeowners.incidents,
            propertyOtherDamageVM: claimVM.lobs.homeowners.propertyOtherDamage,
            isComponentValid: isComponentValid,
            onValidate: onValidate,
            onIncidentUpdates: (value) => {
                _.set(claimVM, `lobs.homeowners.propertyOtherDamage.value`, value);
                updateWizardData(claimVM);
            }
        }
    };

    const resolvers = {
        resolveComponentMap: {losspropertyincidentdetail: LossPropertyIncidentDetail},
        resolveCallbackMap: {
            onValidate: onValidate
        }
    }

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}            
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

FNOLFireDamagePage.propTypes = wizardProps;
export default withRouter(FNOLFireDamagePage);
